<template>
	<div class="load-file-input-container" :style="`height:${height}px`">
		<input
			v-if="showInput"
			disabled
			class="load-input"
			:style="`border-color:${$appColors.gray}`"
			v-bind="$attrs"
			:value="value"
		/>
		<input
			hidden 
			type="file"
			ref="load"
			:accept="allowedFileExtensions"
			@change="getFile"
		/>
		<app-button
			icon-after
			:class="[ classBtn || 'load-btn']"
			:icon="icon"
			:icon-color="color"
			:style="`background-color:${$appColors.success}`"
			@click="loadFile"
		/>
	</div>
</template>
<script>
import appButton from '@/components/shared/app-button';

function loadFile() {
	this.$refs.load.click();
}

function getFile(e) {
	const [file] = e.target.files;
	const [fileName, fileExt] = file.name.split('.');
	const reader = new FileReader();
	reader.onload = async (f) => {
		const fileData = {
			name: fileName.replace(/\s/g, '-'),
			base64data: f.target.result,
			type: fileExt,
		};
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		try {
			const { data: response } = await this.$httpPraktiko.post(
				'external-api/upload-file', fileData, { headers });
			this.$emit('input', response.data.url_image);
			this.$store.dispatch(
				'showSnackBar', { text: `Archivo: "${fileName}" cargado`, color: 'success' });
		} catch (err) {
			let text = '';
			if (err.status === 500) {
				text = 'Error del servidor';
			}
			this.$store.dispatch('showSnackBar', { text, color: 'error' });
		}
	};
	reader.readAsDataURL(file);
}

export default {
	name: 'load-file-input',
	components: {
		appButton,
	},
	inheritAttrs: false,
	methods: {
		getFile,
		loadFile,
	},
	props: {
		allowedFileExtensions: {
			default: '.png, .jpg',
			type: String,
		},
		height: {
			default: 32,
			type: Number,
		},
		showInput: {
			type: Boolean,
			default: true,
		},
		icon: {
			type: String,
			default: 'attach_file',
		},
		color: {
			type: String,
			default: 'white',
		},
		classBtn: {
			type: String,
			default: '',
		},
		value: null,
	},
};
</script>
<style lang="scss" scoped>
.load-file-input-container {
	align-items: center;
	display: flex;
	justify-content: flex-start;

	.load-input {
		background-color: white;
		border-bottom: 1px solid;
		border-top: 1px solid;
		border-left: 1px solid;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		flex-basis: 90%;
		height: 100%;
		padding-left: 20px;
	}

	.load-input::placeholder {
		color: color(gray-medium);
	}

	.load-btn {
		height: 100%;
		flex-basis: 12%;
	}

	.circle-btn {
		background: color(white);
		border-radius: 50%;
		padding: 6px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/load-file-input.vue